import {FormBuilder, Validators} from '@angular/forms';
import {CustomValidators} from '../../../shared/validators/custom-validators';

export class AuthenticationFormFactory {
  static createLoginForm(fb: FormBuilder) {
    return fb.group({
      email: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });
  }

  static createSetPasswordForm(fb: FormBuilder) {
    return fb.group({
        verificationCode: ['', Validators.required],
        password: ['', [Validators.required, Validators.minLength(8)]],
        passwordRepeat: ['', [Validators.required, Validators.minLength(8)]],
      },
      {validators: [CustomValidators.passwordMatch]}
    );
  }
}
